import { events } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
import type { ProductType } from "@memorang/types";

import { useAppStore } from "@hooks/useAppStore";
import DialogWrapper from "@memorang/ui/components/DialogWrapper";
import { useTranslation } from "react-i18next";
/* -----------------UI--------------- */
import { Dialog as PaperDialog } from "react-native-paper";
import PurchaseContainer from "./PurchaseContainer";

type Props = {
	visible: boolean;
	handleClose: () => void;
	productType: ProductType;
	fromPracticeTestPage?: boolean;
	fromHomePage?: boolean;
	explicitProductNumericId?: number;
	explicitProductId?: string;
	handleBack?: () => void;
};
export const PurchaseDialog = ({
	visible,
	handleClose,
	productType,
	fromPracticeTestPage,
	fromHomePage,
	explicitProductNumericId,
	explicitProductId,
	handleBack,
}: Props) => {
	const { explicitCallTrackCustomEvent } = useAnalytics();
	const practiceTestLabel = useAppStore(
		(state) => state.exam.practiceTest?.label,
	);
	const handleDialogClose = () => {
		handleClose();
		explicitCallTrackCustomEvent({
			eventName: events.paywallClosed,
		});
	};
	const { t } = useTranslation();
	const getTitle = () => {
		switch (productType) {
			case "STUDY_PACK":
				return t("purchase.paywall.studyPackDialogTitle");
			case "PRACTICE_TEST":
				return practiceTestLabel
					? `Unlock ${practiceTestLabel ?? "Practice Tests"}`
					: t("purchase.paywall.practiceTestDialogTitle");
			default:
				return t("purchase.paywall.defaultDialogTitle");
		}
	};
	const title = getTitle();
	return (
		<DialogWrapper
			visible={visible}
			handleClose={handleDialogClose}
			handleBack={handleBack}
			minHeight={420}
			showCloseButton
		>
			<PaperDialog.Title style={{ textAlign: "center" }}>
				{title}
			</PaperDialog.Title>
			<PurchaseContainer
				fromPracticeTestPage={fromPracticeTestPage}
				handleClose={handleDialogClose}
				productType={productType}
				fromHomePage={fromHomePage}
				explicitProductId={explicitProductId}
				explicitProductNumericId={explicitProductNumericId}
			/>
		</DialogWrapper>
	);
};
